/**
 * @generated SignedSource<<f9c55e7857af3fa8a39740f081514784>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime'
export type postPage_buildTargetQuery$variables = {
  from: number
}
export type postPage_buildTargetQuery$data = {
  readonly listPosts: {
    readonly items: ReadonlyArray<{
      readonly slug: string
      readonly redirect_to: string | null
    }>
    readonly pagination: {
      readonly hasNext: boolean
      readonly to: number
    }
  }
}
export type postPage_buildTargetQuery = {
  variables: postPage_buildTargetQuery$variables
  response: postPage_buildTargetQuery$data
}

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'from'
      }
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Literal',
            name: 'filter',
            value: {
              status: 'published'
            }
          },
          {
            fields: [
              {
                kind: 'Variable',
                name: 'from',
                variableName: 'from'
              },
              {
                kind: 'Literal',
                name: 'size',
                value: 50
              }
            ],
            kind: 'ObjectValue',
            name: 'page'
          }
        ],
        concreteType: 'PostResult',
        kind: 'LinkedField',
        name: 'listPosts',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'Post',
            kind: 'LinkedField',
            name: 'items',
            plural: true,
            selections: [
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'slug',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'redirect_to',
                storageKey: null
              }
            ],
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'PaginationStatus',
            kind: 'LinkedField',
            name: 'pagination',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'hasNext',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'to',
                storageKey: null
              }
            ],
            storageKey: null
          }
        ],
        storageKey: null
      }
    ]
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'postPage_buildTargetQuery',
      selections: v1 /*: any*/,
      type: 'Query',
      abstractKey: null
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'postPage_buildTargetQuery',
      selections: v1 /*: any*/
    },
    params: {
      cacheID: '02a3e6ef4d8fc4c38ab38ba4a3387674',
      id: null,
      metadata: {},
      name: 'postPage_buildTargetQuery',
      operationKind: 'query',
      text: 'query postPage_buildTargetQuery(\n  $from: Int!\n) {\n  listPosts(filter: {status: "published"}, page: {from: $from, size: 50}) {\n    items {\n      slug\n      redirect_to\n    }\n    pagination {\n      hasNext\n      to\n    }\n  }\n}\n'
    }
  }
})()

;(node as any).hash = '0c1ab40aaa03f63785e66f132571641b'

export default node
